import React from 'react';
import { useLanguage } from '../LanguageContext';
import './Hero.css';

const Hero: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">{t.hero.title}</h1>
          <p className="hero-subtitle">{t.hero.subtitle}</p>
          
          <div className="hero-cta">
            <a href="#contact" className="btn btn-primary">{t.hero.cta}</a>
            <a href="#services" className="btn btn-secondary">{t.hero.ctaSecondary}</a>
          </div>

          <div className="hero-partners">
            <p className="partners-label">{t.hero.partnersLabel}</p>
            <div className="partners-logos">
              <span className="partner-logo">Econt</span>
              <span className="partner-logo">Speedy</span>
              <span className="partner-logo">DHL</span>
            </div>
          </div>
        </div>

        <div className="hero-visual">
          <div className="process-flow">
            {/* Order Flow */}
            <div className="flow-section order-flow">
              <h3 className="flow-title">{t.hero.processFlow.orderTitle}</h3>
              <div className="flow-container">
                <div className="flow-step step-1">
                  <div className="step-icon">🛒</div>
                  <div className="step-label">{t.hero.processFlow.clientOrder}</div>
                </div>
                <div className="flow-arrow arrow-1">→</div>
                
                <div className="flow-step step-2">
                  <div className="step-icon">🌐</div>
                  <div className="step-label">{t.hero.processFlow.systemCall}</div>
                </div>
                <div className="flow-arrow arrow-2">→</div>
                
                <div className="flow-step step-3">
                  <div className="step-icon">📦</div>
                  <div className="step-label">{t.hero.processFlow.packageItems}</div>
                </div>
                <div className="flow-arrow arrow-3">→</div>
                
                <div className="flow-step step-4">
                  <div className="step-icon">📋</div>
                  <div className="step-label">{t.hero.processFlow.createShipment}</div>
                </div>
                <div className="flow-arrow arrow-4">→</div>
                
                <div className="flow-step step-5">
                  <div className="step-icon">🚚</div>
                  <div className="step-label">{t.hero.processFlow.toCourier}</div>
                </div>
              </div>
            </div>
            
            {/* Return Flow */}
            <div className="flow-section return-flow">
              <h3 className="flow-title">{t.hero.processFlow.returnTitle}</h3>
              <div className="flow-container">
                <div className="flow-step return-step-1">
                  <div className="step-icon">📦</div>
                  <div className="step-label">{t.hero.processFlow.receiveReturn}</div>
                </div>
                <div className="flow-arrow return-arrow-1">→</div>
                
                <div className="flow-step return-step-2">
                  <div className="step-icon">📸</div>
                  <div className="step-label">{t.hero.processFlow.inspectPhoto}</div>
                </div>
                <div className="flow-arrow return-arrow-2">→</div>
                
                <div className="flow-step return-step-3">
                  <div className="step-icon">✅</div>
                  <div className="step-label">{t.hero.processFlow.acceptReject}</div>
                </div>
              </div>
            </div>
            
            {/* Animated Elements */}
            <div className="animated-package package-1">📦</div>
            <div className="animated-package package-2">📦</div>
            <div className="animated-truck">🚚</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

